import React from 'react'

const IconRightArrowTable = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M12.9463 12L8.34625 7.4L9.4 6.34625L15.0538 12L9.4 17.6538L8.34625 16.6L12.9463 12Z'
        fill='#686867'
      />
    </svg>
  )
}

export default IconRightArrowTable
